// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"c2eddb6c","63":"2739cfcc","68":"3b779f4f","101":"70f62472","102":"874b4199","104":"538b2ca1","143":"7669407a","145":"d5213bfe","165":"7a117dec","497":"6186825b","595":"99446704","638":"5f95effb","685":"1922b76f","743":"3ce8850e","744":"0e98a167","823":"a99233bf"}[chunkId] + ".js";
};